"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedLayoutContext = exports.LayoutContext = void 0;
const react_1 = require("react");
exports.LayoutContext = (0, react_1.createContext)({});
exports.EmbedLayoutContext = "embed";
//# sourceMappingURL=LayoutContext.js.map